export default {
    getModelPubl: (state) => {
        return state.publicacion
    }
}